import { useEffect, useState } from "react";
import { fetchPageCms } from "../lib/cms";

export function usePageCms(page) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    fetchPageCms(page)
      .then((d) => alive && setData(d))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [page]);

  return { data, loading };
}
